import { render, staticRenderFns } from "./ShunyiHome.vue?vue&type=template&id=408b0a18&scoped=true"
import script from "./ShunyiHome.vue?vue&type=script&lang=js"
export * from "./ShunyiHome.vue?vue&type=script&lang=js"
import style0 from "./ShunyiHome.vue?vue&type=style&index=0&id=408b0a18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408b0a18",
  null
  
)

export default component.exports